var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M41.844,15.036l-2.581-2.654a.555.555,0,0,0-.411-.176h0a.532.532,0,0,0-.411.176L20.552,30.4l-6.511-6.511a.567.567,0,0,0-.821,0L10.61,26.5a.584.584,0,0,0,0,.836l8.212,8.212a2.6,2.6,0,0,0,1.716.836,2.721,2.721,0,0,0,1.7-.806h.015L41.858,15.872A.627.627,0,0,0,41.844,15.036Z",
    transform: "translate(4.288 6.211)",
    fill: "#79b62f",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M33.875,7.481A26.4,26.4,0,0,1,52.542,52.542,26.4,26.4,0,0,1,15.208,15.208,26.22,26.22,0,0,1,33.875,7.481m0-4.106a30.5,30.5,0,1,0,30.5,30.5,30.5,30.5,0,0,0-30.5-30.5Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#79b62f",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.3d37194309d67413a8a1c3ca012b1e4b.svg";
export { ForwardRef as ReactComponent };